"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrillAttributeSelectorItem = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var model_1 = require("../../../../../model");
var sdk_model_1 = require("@gooddata/sdk-model");
exports.DrillAttributeSelectorItem = function (props) {
    var item = props.item;
    var onClick = function () {
        props.onClick(item);
        props.onCloseDropdown();
    };
    var name = item.attribute.attributeHeader.formOf.name;
    var dateAttributes = model_1.useDashboardSelector(model_1.selectCatalogDateDatasets);
    var isFromDateAttribute = dateAttributes.some(function (attribute) {
        return attribute.dateAttributes.some(function (dateAttribute) {
            return sdk_model_1.areObjRefsEqual(dateAttribute.attribute.ref, item.attribute.attributeHeader.formOf.ref);
        });
    });
    return (react_1.default.createElement("a", { onClick: onClick, className: classnames_1.default("s-drill-attribute-selector-item", {
            "gd-drill-attribute-selector-list-item": !isFromDateAttribute,
            "gd-drill-attribute-date-selector-list-item": isFromDateAttribute,
        }), title: name }, name));
};
//# sourceMappingURL=DrillAttributeSelectorItem.js.map